import { stratify } from "d3";

import { setFromArrayValues } from "../../utils";
import { tree } from "./render";
import companyDictionary from "./dictionary.json";

export const makeHierarchy = (data) => {
  const companies = [
    ...setFromArrayValues(
      data,
      (d) => d.source,
      (d) => d.target
    ),
  ].filter((a) => a);
  let s = [
    ...companies.map((c) => ({ name: c, parent: null })),
    { name: "root", parent: null },
  ];
  // debugger;
  for (let d of data) {
    const parent = s.find((s) => s.name === d.source);
    const child = s.find((s) => s.name === d.target);
    // console.log(d, parent, child);
    child.parent = parent.name;
  }

  s.forEach((company) => {
    if (company.name !== "root" && !company.parent) {
      company.parent = "root";
    }
  });

  return stratify()
    .id(function (d) {
      return d.name;
    })
    .parentId(function (d) {
      return d.parent;
    })(s);
};

export const makeNetworkFromNarrative = (unfilteredData, orientation) => {
  const data = unfilteredData.filter((d) => d?.type !== "partial_ownership");

  const stratifiedData = makeHierarchy(data);

  let treeDepth = 1;
  stratifiedData.each((n) => {
    if (n.depth > treeDepth) treeDepth = n.depth;
  });

  const hierarchy = tree(orientation, treeDepth + 1)(stratifiedData);

  // cache the lookups by mutating the hierarchy
  hierarchy.each((n) => {
    const lookup = companyDictionary.find((c) => c.name === n.id);
    n.data.country = lookup?.country || "none";
    n.data.notes = lookup?.notes || "";
    n.data.type = lookup?.type || "";
    n.data.incorporation_date = lookup?.incorporation_date || "";
  });

  const partialEdges = unfilteredData
    .filter((d) => d?.type === "partial_ownership")
    .map((d) => {
      const lookup = companyDictionary.find((c) => c.name === d.source);
      return {
        ...d,
        country: lookup?.country,
        type: lookup?.type,
      };
    });

  // do lookups in dictionary
  return {
    root: hierarchy,
    partialEdges,
  };
};
